import Vue from 'vue';
import Vuex from 'vuex';

import VuexORM from '@vuex-orm/core';

import Form from './models/Form';
import forms from './modules/forms';
import Entry from './models/Entry';
import entries from './modules/entries';

Vue.use(Vuex);

// Create new instance of Database.
const database = new VuexORM.Database();

// Register Model and Module. The First argument is the Model, and
// second is the Module.
database.register(Form, forms);
database.register(Entry, entries);

export default database;
